export default __webpack_public_path__ + "static/media/main1_banner.e1740272.png";